import sensors from "sa-sdk-javascript";

const TEST_SERVER_URL = "https://sensors.yingzhongshare.com/sa?project=test";
const PROD_SERVER_URL = "https://sensors.yingzhongshare.com/sa?project=tuanzi";
export const PRD_ID = 2210103;

sensors.init({
  server_url: ["test", "development"].includes(import.meta.env.VITE_ENV) ? TEST_SERVER_URL : PROD_SERVER_URL, // 这里填写申请的地址
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  //   show_log: import.meta.env.VITE_ENV !== 'development', // 是否显示埋点输出
  show_log: ["test", "development"].includes(import.meta.env.VITE_ENV),
  send_type: "beacon",
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: ["test", "development"].includes(import.meta.env.VITE_ENV) ? "not_collect" : "default",
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: ["test", "development"].includes(import.meta.env.VITE_ENV) ? "not_collect" : "default"
  }
});

const sensorsStore = sensors.getPresetProperties();

// 初始化用户标识
let DEFAULT_DISTINCT_ID = sensorsStore.identities.$identity_cookie_id;
const regex = new RegExp(PRD_ID + "-", "g");
DEFAULT_DISTINCT_ID = DEFAULT_DISTINCT_ID.replace(regex, "");
export const ANONYMOUS_ID = PRD_ID + "-" + DEFAULT_DISTINCT_ID;
export const DEFAULT_ANONYMOUS_ID = "2210103-8888888888888888888";

sensors.identify(ANONYMOUS_ID, true);

// 导出配置
export default sensors;
